export type BrandOrderSourceType =
  | 'MARKETPLACE'
  | 'ELEVATE'
  | 'TRADESHOW'
  | 'MARKETPLACE_PAID_PLACEMENT';

export enum BrandOrderSource {
  MARKETPLACE = 'MARKETPLACE',
  ELEVATE = 'ELEVATE',
  TRADESHOW = 'TRADESHOW',
  MARKETPLACE_PAID_PLACEMENT = 'MARKETPLACE_PAID_PLACEMENT',
}
